var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import dayjs from 'dayjs';
import { BigNumber, ethers } from 'ethers';
import { t } from 'i18next';
import { getTokenContract, SupportedTokens } from '@sovryn/contracts';
import { TransactionReceiptStatus, TransactionType, } from '../app/3_organisms/TransactionStepDialog/TransactionStepDialog.types';
import { APPROVAL_FUNCTION } from '../constants/general';
import { getTokenDisplayName } from '../constants/tokens';
import { translations } from '../locales/i18n';
import { getRskChainId } from './chain';
export const UNSIGNED_PERMIT = {
    deadline: 0,
    v: 0,
    r: ethers.constants.HashZero,
    s: ethers.constants.HashZero,
};
export const preparePermitTransaction = ({ token = SupportedTokens.dllr, chain = getRskChainId(), signer, spender, value, deadline = prepareDeadline(), nonce, }) => __awaiter(void 0, void 0, void 0, function* () {
    const { address: tokenAddress } = yield getTokenContract(token, chain);
    return {
        title: t(translations.common.tx.signPermitTitle, {
            symbol: getTokenDisplayName(token),
        }),
        subtitle: t(translations.common.tx.signPermitSubtitle, {
            symbol: getTokenDisplayName(token),
        }),
        request: {
            type: TransactionType.signPermit,
            signer,
            token: tokenAddress,
            owner: yield signer.getAddress(),
            spender,
            value,
            deadline,
            nonce,
        },
    };
});
export const prepareApproveTransaction = ({ token = SupportedTokens.dllr, chain = getRskChainId(), spender, amount = '0', signer, contract, }) => __awaiter(void 0, void 0, void 0, function* () {
    const loadTokenContract = () => __awaiter(void 0, void 0, void 0, function* () {
        if (contract) {
            return contract;
        }
        else if (signer) {
            const { address: tokenAddress, abi } = yield getTokenContract(token, chain);
            return new ethers.Contract(tokenAddress, abi, signer);
        }
        throw new Error('signer or contract must provided, but not both.');
    });
    const tokenContract = yield loadTokenContract();
    const owner = yield tokenContract.signer.getAddress();
    const allowance = yield tokenContract.allowance(owner, spender);
    if (BigNumber.from(allowance).lt(amount)) {
        return {
            title: t(translations.common.tx.signApproveTitle, {
                symbol: getTokenDisplayName(token),
            }),
            subtitle: t(translations.common.tx.signApproveSubtitle, {
                symbol: getTokenDisplayName(token),
            }),
            request: {
                type: TransactionType.signTransaction,
                contract: tokenContract,
                fnName: APPROVAL_FUNCTION,
                args: [spender, amount],
            },
        };
    }
});
export const permitHandler = (override, permitIndex = 0) => (request, receipts) => {
    var _a, _b;
    if (receipts.length &&
        ((_a = receipts[permitIndex]) === null || _a === void 0 ? void 0 : _a.status) === TransactionReceiptStatus.success &&
        ((_b = receipts[permitIndex]) === null || _b === void 0 ? void 0 : _b.request.type) === TransactionType.signPermit) {
        return override(request, receipts[permitIndex].response);
    }
    return request;
};
export const prepareDeadline = (value = 1, unit = 'hour') => dayjs().add(value, unit).unix();
